import { i18n } from '@/lib/i18n/i18n';
import { useEffect } from 'react';
import { Navigate, useParams } from 'react-router-dom';

type LocaleSwitcherProps = {
    targetLocale: string;
};

/**
 * Component that switches the app language and redirects to the current path (without locale prefix)
 * Used for /en and /de routes to handle language switching
 *
 * Examples:
 * - /en/customers -> switches to English, redirects to /customers
 * - /de -> switches to German, redirects to /
 */
export const LocaleRedirect: React.FC<LocaleSwitcherProps> = ({ targetLocale }) => {
    const { '*': path } = useParams();

    useEffect(() => {
        // Update i18n language
        i18n.changeLanguage(targetLocale);
    }, [targetLocale]);

    return <Navigate to={`/${path ?? ''}`} replace />;
};
